import { ja } from './ja';
import { en } from './en';

const translations: Record<string, Record<string, string>> = { ja, en };
let currentLang = 'ja';

export function setLanguage(lang: string): void {
  currentLang = lang;
  document.querySelectorAll('[data-i18n]').forEach(el => {
    const key = el.getAttribute('data-i18n')!;
    el.textContent = t(key);
  });
}

export function getLanguage(): string {
  return currentLang;
}

export function t(key: string): string {
  return translations[currentLang]?.[key] ?? translations['en']?.[key] ?? key;
}
